import Store from '@repo/datalayer/store/models/Store'
import { createContext, useContext } from 'react'

export const StoreContext = createContext<Store | null>(null)

export function useStore() {
  const found = useContext(StoreContext)

  if (!found) throw 'Store Context not set'

  return found
}
